import { IrrigationOfficeModel } from '@roi/common/models/irrigation-office.model';
import { createAction, props } from '@ngrx/store';
import { ActivityModel } from '@roi/common/models/activity.model';
import { PlantModel } from '@roi/common/models/plant.model';
import { ProjectModel } from '@roi/common/models/project.model';
import { StatusModel } from '@roi/common/models/water-allocation-status.model';

export const loadYears = createAction('[MASTER][SET]:Years');

export const SetYears = createAction(
  '[MASTER][SET]:Years Success',
  props<{
    years: {
      id: string;
      year: number;
      name: string;
    }[];
  }>()
);
export const loadLandUse = createAction('[MASTER][SET]:LandUse');

export const SetLandUse = createAction(
  '[MASTER][SET]:LandUse Success',
  props<{
    landUse: PlantModel[];
  }>()
);
export const loadWaterUse = createAction('[MASTER][SET]:WaterUse');

export const SetWaterUse = createAction(
  '[MASTER][SET]:WaterUse Success',
  props<{
    waterUse: ActivityModel[];
  }>()
);
export const loadIrrigationOffices = createAction(
  '[MASTER][SET]:IrrigationOffice'
);

export const SetIrrigationOffices = createAction(
  '[MASTER][SET]:IrrigationOffices Success',
  props<{
    irrigationOffices: IrrigationOfficeModel[];
  }>()
);
export const loadProjects = createAction(
  '[MASTER][SET]:Project',
  props<{ irrigation_office_id: string | null }>()
);

export const SetProjects = createAction(
  '[MASTER][SET]:Project Success',
  props<{
    projects: ProjectModel[];
  }>()
);

export const loadStatus = createAction('[MASTER][SET]:Status');

export const SetStatus = createAction(
  '[MASTER][SET]:Status Success',
  props<{
    status: StatusModel[];
  }>()
);
